export default __webpack_public_path__ + "static/media/5.ebb0e6a4.png";